export default __webpack_public_path__ + "static/dropdownMenu_cloud_front-ae3d3df1e9b68586afdb4daa143a0a2c.png";